<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-wardrobe`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M32 17a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2zm-14 0a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2zM42.238 3C43.211 3 44 3.658 44 4.47v34.06c0 .812-.789 1.47-1.762 1.47H38v4a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4H14v4a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4H5.762C4.789 40 4 39.342 4 38.53V4.47C4 3.659 4.789 3 5.762 3h36.476zM22 7H8v29h14V7zm18 0H26v29h14V7z"/></svg>
</template>
<script>

export default {
  name: 'IconWardrobe',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
